import { ReactiveVar } from '@apollo/client';
import {
  ErrorArguements,
  AvailableError,
  FatalError,
  NonFatalError,
  UnimportantError,
  OrganizationNotFound,
  UserNotFound,
  SigninRequired,
} from './index';

export default function setErrors(errorsVar: ReactiveVar<AvailableError[] | null>) {
  return (error: Error | ErrorArguements, nameOverride?: string): void => {
    const currentErrors = errorsVar() ?? [];

    if (nameOverride) error.name = nameOverride;
    if (error instanceof Error) {
      errorsVar([...currentErrors, error]);
      return;
    }

    if (error?.message?.includes('auth') || (error?.status && error.status === 400)) {
      const fatalError = new FatalError(error.message);
      errorsVar([...currentErrors, fatalError]);
      return;
    }
    errorsVar([...currentErrors, initializeInstance(error)]);
  };
}

const initializeInstance = (error: ErrorArguements) => {
  switch (error.name) {
    case 'NonFatalError':
      return new NonFatalError(error);
    case 'UnimportantError':
      return new UnimportantError(error);
    case 'OrganizationNotFound':
      return new OrganizationNotFound(error);
    case 'UserNotFound':
      return new UserNotFound(error);
    case 'VerificationNeeded':
      return new SigninRequired(error);
    default:
      return new NonFatalError(error);
  }
};
